import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withStyles } from 'styles';
import styles from './styles';
import { CrudActions } from 'actions';
import RichTextInput from 'components/RichTextInput';

const TextArea = memo(({ description, field, hidden, hintText, mandatory, styles: stylesProp }) => {
    const dispatch = useDispatch();
    const value = useSelector((state) => state.crud.entityCrud.get(field.id.id.toLowerCase()));
    const literals = useSelector((state) => state.literal.literals);

    const onChange = useCallback(
        (newValue) => {
            if (newValue && (newValue.html || newValue.text)) {
                dispatch(CrudActions.updateFieldCrud(field.id.id.toLowerCase(), newValue.html));
                dispatch(
                    CrudActions.updateFieldCrud(
                        field.id.descriptionText.toLowerCase(),
                        newValue.text,
                    ),
                );
            } else {
                dispatch(CrudActions.removeFieldCrud(field.id.id.toLowerCase()));
                dispatch(CrudActions.removeFieldCrud(field.id.descriptionText.toLowerCase()));
            }
        },
        [dispatch, field.id.id, field.id.descriptionText],
    );

    if (hidden) return null;

    const hint = literals[hintText] ? literals[hintText] : hintText;

    return (
        <div style={stylesProp.fieldContainerTextEditor}>
            {description && (
                <span style={stylesProp.title}>
                    {description} {mandatory ? '*' : ''}
                </span>
            )}
            <RichTextInput defaultValue={value} hint={hint} onChange={onChange} />
        </div>
    );
});

TextArea.displayName = 'TextArea';

export default withStyles(styles)(TextArea);
